export { Angular } from './angular';
export { CaptureConsole } from './captureconsole';
export { Debug } from './debug';
export { Dedupe } from './dedupe';
export { Ember } from './ember';
export { ExtraErrorData } from './extraerrordata';
export { Offline } from './offline';
export { ReportingObserver } from './reportingobserver';
export { RewriteFrames } from './rewriteframes';
export { SessionTiming } from './sessiontiming';
export { Transaction } from './transaction';
export { Vue } from './vue';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/integrations/esm/index.js
// module id = 424
// module chunks = 1